import styled from "styled-components";

interface SupportProps {
  hasAccess: boolean;
}

export const ContentSupportWpp = styled.div<SupportProps>`
  width: 200px;
  top: 12px;
  border-width: 1px;
  flex-direction: column;
  cursor: ${(props) => (props.hasAccess ? "pointer" : "not-allowed")};


`;

export const ContentCommercial = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
  cursor: pointer;


`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border-top: 2px solid #313131;
  margin-bottom: 18px;

  .plan-sidebar {
    font-size: 16px;
    user-select: none;
    color: var(--velotax-font-color-light);
    &.pointer {
      cursor: pointer;
    }
    strong {
      font-weight: 900;
    }
  }
`;

export const ContentNotHasAccess = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 8px;
`;

export const TextContainer = styled.div<SupportProps>`
  width: 160;
  height: 52;
  display: flex;
  flex-direction: column;
  top: 30px;
  left: 16px;
  padding: ${(props) => (props.hasAccess ? "8px 8px" : "0px 0px")};
  gap: 4px;
`;

export const Title = styled.span<SupportProps>`
  width: 165px;
  height: 16px;
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #fbc105;
`;

export const InfoText = styled.span`
  font-family: Roboto;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #ffffff;
`;

export const InfoText2 = styled.p`
  font-family: Roboto;
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #FFFFFf
`;

export const ScheduleText = styled.span`
  font-family: Roboto;
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #ffffff;
`;

export const Button = styled.button`
  width: 170px;
  height: 40;
  top: 112px;
  left: 20px;
  border-bottom-width: 2px;
  padding: 12px;
  gap: 10px;
  background-color: #fbc105;
  color: #000000;
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
`;